import { Node as ProseMirrorNode } from 'prosemirror-model';

import { ContentType } from '../../../../../../components/EditorBuilder/types';

export const findLessonHierarchyNameId = (courseContent?: ContentType[], id?: string | null) => {
  if (!courseContent || !id) {
    return '';
  }

  let rootLesson = 1;

  for (let i = 0; i < courseContent.length; i++) {
    const section = courseContent[i];
    if (section.content?.length) {
      for (let j = 0; j < section.content?.length; j++) {
        const lesson = section.content[j];

        if (lesson?.type === 'ly__lesson') {
          if (lesson.attrs?.id === id) {
            return `${rootLesson}`;
          }

          let subLessonId = 1;
          if (lesson.content?.length) {
            for (let k = 0; k < lesson.content.length; k++) {
              const subLesson = lesson.content[k];

              if (subLesson?.type === 'ly__lesson') {
                if (subLesson.attrs?.id === id) {
                  return `${rootLesson}.${subLessonId}`;
                }

                subLessonId++;
              }
            }
          }

          rootLesson++;
        }
      }
    }
  }
};

export const isLastNode = (doc?: ProseMirrorNode, id?: string) => {
  if (!doc) {
    return false;
  }

  return doc.lastChild?.attrs?.id === id;
};
